import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [msg, setMsg] = useState('');
  const navigate = useNavigate();

  // Validate password (at least 6 characters, 1 number, 1 special character)
  const validatePassword = (password) => {
    const lengthOk = password.length >= 6;
    const numberOk = /\d/.test(password);
    const specialOk = /[!@#$%^&*(),.?":{}|<>]/.test(password);
    return lengthOk && numberOk && specialOk;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      return setMsg('❌ Passwords do not match.');
    }

    if (!validatePassword(password)) {
      return setMsg('❌ Password must be at least 6 characters and include a number and special character.');
    }

    // Retrieve users from localStorage
    const users = JSON.parse(localStorage.getItem('users')) || [];
    const user = users.find((u) => u.email === email);

    if (!user) {
      return setMsg('❌ No account found with this email address.');
    }

    // Update the password in the users list
    user.password = password;
    localStorage.setItem('users', JSON.stringify(users));

    setMsg('✅ Password reset successful!');
    setTimeout(() => navigate('/login'), 1500); // Redirect to login after a few seconds
  };

  return (
    <div className="container mt-5">
      <h2>Reset Your Password</h2>
      {msg && <div className="alert alert-info">{msg}</div>}
      <form onSubmit={handleSubmit}>
        <input
          className="form-control mb-3"
          type="email"
          placeholder="Enter your registered email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <input
          className="form-control mb-3"
          type="password"
          placeholder="Enter new password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <input
          className="form-control mb-3"
          type="password"
          placeholder="Confirm new password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          required
        />
        <button className="btn btn-primary w-100">Reset Password</button>
      </form>
      <p className="mt-3">
        Remember your password? <a href="/login">Login here</a>
      </p>
    </div>
  );
};

export default ForgotPassword;
